import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';

import MultimediaForm from '../form/MultimediaForm';
import { MultimediaParams, MultimediaValues } from '../model/multimediaModel';
import { ROUTES } from '../../../core/router/routes';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings/SnackbarSettings';
import * as Selectors from '../redux/multimediaSelectors';
import * as Actions from '../redux/multimediaActions';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

const breadcrumbs = [
  {
    label: 'multimedia.edit',
    to: null,
  },
];

let disableSuccessSnackbarAction = true;

const MultimediaAdd: React.FC = () => {
  const params = useParams<MultimediaParams>();
  const dispatch = useDispatch();
  const history = useHistory();
  const initialValues = useSelector(Selectors.initialValues);
  const apiRequestState = useSelector(Selectors.apiMultimediaRequestState);
  const apiRequestError = useSelector(Selectors.apiMultimediaRequestError);
  const { show, hide } = useMainProgressContext();

  useEffect(() => {
    dispatch(Actions.getMultimedia(params));
  }, [params]);

  useEffect(() => {
    if (initialValues.file && apiRequestState !== API_REQUEST_STATE.LOADING) {
      hide();
    }
  }, [initialValues]);

  useEffect(
    () => () => {
      dispatch(Actions.resetMultimedia());
    },
    [],
  );

  return (
    <>
      <SnackbarSettings
        disableSuccessAction={disableSuccessSnackbarAction}
        successMessage="multimedia.snackbar.edit_success"
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiMultimediaRequestState}
        onSuccess={() => {
          history.push(ROUTES.MULTIMEDIA.LIST);
        }}
      />
      <MultimediaForm
        breadcrumbs={breadcrumbs}
        title="multimedia.edit"
        initialValues={initialValues}
        onSubmit={(values: MultimediaValues) => {
          show();
          disableSuccessSnackbarAction = false;
          dispatch(
            Actions.editMultimedia(params, {
              name: values.name,
            }),
          );
        }}
      />
    </>
  );
};

export default MultimediaAdd;
